export const chatbot = {
   p1: `Skonfiguruj Wirtualnego Asystenta`,
   p2: `Włącz usługę chatbota, aby automatycznie odpowiadać na najczęstsze pytania gości.`,
   p3: `Skonfiguruj Wirtualnego Asystenta. Dostosuj odpowiedzi chatbota, aby przekazywać gościom szybkie i precyzyjne informacje. Automatycznie rozwiązuj ich najczęstsze wątpliwości.`,
   p4: `Konfiguruj`,
   p5: `Wirtualny Asystent został włączony`,
   p6: `Wirtualny Asystent został wyłączony`,

   p7: `Skonfiguruj odpowiedzi ChatBota`,
   p8: `Przypisany obiekt:`,
   p9: `Dostosuj automatyczne odpowiedzi chatbota, aby sprawnie reagować na najczęstsze pytania gości.`,

   p10: `Masz niezapisane zmiany. Czy chcesz je odrzucić i przejść do innego pytania?`,

   p11: `Pytanie:`,
   p12: `Dołącz zdjęcie do odpowiedzi`,
   p13: `Prześlij zdjęcie`,
   p14: `Usuń zdjęcie`,
   p15: `Zapisz odpowiedź`,
   p16: `Odpowiedź została zapisana`,
   p17: `Podczas zapisywania odpowiedzi wystąpił błąd.`,

   p18: `Podczas usuwania zdjęcia wystąpił błąd.`,
   p19: `Wpisz swoją odpowiedź...`,

   p20: `Blok odpowiedzi`,
   p21: `Podgląd`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}
